var LazyloadImages = {
  init: function(){
    LazyloadImages.insertImageSrc();
  },
  isElementInViewport: function(el){
    var rect = el.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top <= (window.innerHeight)) {
      return true;
    } else {
      return false;
    }
  },
  insertImageSrc: function(){
    var imgSrc;
    $('.coll-product-img[data-img-src], .product-filter-img[data-img-src]').each(function(){
      imgSrc = $(this).data('img-src')
      if(LazyloadImages.isElementInViewport(this)){
        $(this).attr('src', imgSrc)
        $(this).on('load', function(){
          $(this).addClass('inview');
          $(this).removeAttr('data-img-src')
        })
      } 
    })
  }
}
  

$(window).on('scroll', function(){
  LazyloadImages.init();  
});

$(document).ready(function() {
  LazyloadImages.init();
})

